export default {
    label_task:{
        en:"Unions",
        bn:'ব্যবহারকারীরা'
    },
    label_new_task:{
        en:"New Union",
        bn:'নতুন ব্যবহারকারী'
    },
    label_edit_task:{
        en:"Edit Union",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    label_details_task:{
        en:"Details of Union",
        bn:'ব্যবহারকারীর বিবরণ'
    },

}